import { TableHead } from '@/components/ui/table'
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react'
import { cn } from '@/lib/utils'

export type SortDirection = 'asc' | 'desc' | null

interface SortableHeaderProps {
  children: React.ReactNode
  sortKey: string
  currentSort?: string | null
  currentDirection?: SortDirection
  onSort?: (key: string, direction: SortDirection) => void
  className?: string
}

export function SortableHeader({
  children,
  sortKey,
  currentSort,
  currentDirection,
  onSort,
  className,
}: SortableHeaderProps) {
  const isActive = currentSort === sortKey

  const handleClick = () => {
    if (!onSort) return

    let newDirection: SortDirection
    if (!isActive) {
      newDirection = 'desc'
    } else if (currentDirection === 'desc') {
      newDirection = 'asc'
    } else {
      newDirection = null
    }

    onSort(sortKey, newDirection)
  }

  const Icon = isActive ? (currentDirection === 'asc' ? ArrowUp : ArrowDown) : ArrowUpDown

  return (
    <TableHead
      className={cn('cursor-pointer select-none hover:bg-muted/50 transition-colors', className)}
    >
      <button
        type="button"
        onClick={handleClick}
        className={cn(
          'flex items-center gap-1 w-full',
          className?.includes('text-right') && 'justify-end',
          className?.includes('text-center') && 'justify-center'
        )}
      >
        <span>{children}</span>
        <Icon
          className={cn('h-3.5 w-3.5 transition-opacity', isActive ? 'opacity-100' : 'opacity-40')}
        />
      </button>
    </TableHead>
  )
}
